import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/contractors',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/list/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/contractors/create',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/create/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/contractor/:id',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/edit/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
